import template from './templates/preview.tmpl';
import AppSettings from '../../core/AppSettings';
import localize from '../../core/localize';
import Loader from "../../core/skins/Core_Metal/Loader";
import DataCapture from './DataCapture';
import ActiveDesignerView from './components/ActiveDesignerView';

export default class Preview {
	constructor(parentElement, img, options = {}) {

		this.parentElement = parentElement;
		this.renderedTemplate = template;

		this.el = document.createElement('div');
		this.el.className = 'preview';
		this.el.innerHTML = this.renderedTemplate;

		const designer = this.parentElement.querySelector('.designer');
		this.parentElement.insertBefore(this.el, designer);
		designer.classList.add('hide');

		const previewContainer = this.el.querySelector('#preview-container');
		const previewWarningContainer = this.el.querySelector('.preview--warning-container');

		localize(this.el, AppSettings.Language);

		this.onClose = options.onClose || (() => { });
		this.onNext = options.onNext || (() => { });

		// Add class for each view
		this.currentViewPage = new ActiveDesignerView();

		this.el.querySelector('#preview--btn-back').onclick = () => {
			this.parentElement.removeChild(this.el);
			this.onClose();
			this.currentViewPage.setActiveView('view-svgOptimisation-wrapper');
		};

		this.el.querySelector('#preview--btn-next').onclick = () => {
			if(AppSettings.isDataCaptureEnabled() || AppSettings.isEmailCaptureEnabled()) {
				this.showDCview(); //Show Data capture view
			}
			else {
				this.onNext(); //Submit the designer in designer.js
			}
		};

		if (AppSettings.isCustomImage) {
			const previewWarning = document.createElement('div');
			previewWarning.className = 'preview-warning';
			previewWarning.innerHTML=AppSettings.Language.previewWarning || "previewWarning";
			previewContainer.classList.add('with-warning');
			this.el.classList.add('with-warning');
			previewWarningContainer.appendChild(previewWarning);			
		}

		const previewFigure = document.createElement('figure');
		previewFigure.className = 'preview-figure';
		previewFigure.appendChild(img);
		previewContainer.appendChild(previewFigure);
		
	}

	showDCview() {		
		new DataCapture(this.parentElement, {
			onClose: () => {
				this.parentElement.querySelector('.preview').classList.remove('hide');
			},

			onNext: () => {
				this.onNext();
			},

		});

		const fieldsData = this.dataCapture ? this.dataCapture.Url[0] : null;
		if(fieldsData) {
			fieldsData.foreach((data) => {
				createInputElement(data);
			});
		}
	}

	createInputElement(data) {
		if(data.Display) {
			const inputWrap = document.createElement('div');
			inputWrap.class = 'input-wrap';

			const inputLabel = document.createElement('label');
			inputLabel.setAttribute('for', data.Id);
			inputLabel.innerText = data.Label;

			const inputElem = document.createElement('input');
			inputElem.id = data.Id;
			inputLabel.setAttribute('type', data.Type);
			inputLabel.setAttribute('value', data.Value);
			inputLabel.setAttribute('required', data.Mandatory);
			inputLabel.setAttribute('value', data.Value);

			inputWrap.appendChild(inputLabel);
			inputWrap.appendChild(inputElem);
			document.appendChild(inputWrap);
		}
	}
}